(function () {
    "use strict";

    // @ngInject
    function ReactLoaderServiceCtor($window, Gon, UsersManager) {

        this.loadReactPromise = new Promise((resolve, reject) => {
            const intervalId = setInterval(() => {
                if ($window.honeybookReact) {
                    clearInterval(intervalId);
                    $window.honeybookReact.loadInfraData(Gon, UsersManager.getCurrUser());

                    resolve($window.honeybookReact);
                }
            }, 500);
        });
    }

    Services.ReactLoaderService = Class(function () {

        return {

            constructor: ReactLoaderServiceCtor,

            getReactInstance: function getReactInstance() {
                return this.loadReactPromise;
            },
        };
    });
}());